(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icons-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rt-icon-rotation')) {
  customElements.define('rt-icon-rotation', class extends HTMLElement {
    connectedCallback() {
      this.rotationTimer = setInterval(() => {
        if (!window.matchMedia('(max-width: 767px)').matches || document.hidden || this.matches(':focus-within')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const track = this.querySelector('.icons-bar-inner');
        if (!track || track.getBoundingClientRect().bottom < 0 || track.getBoundingClientRect().top > window.innerHeight) return;
        const items = Array.from(track.querySelectorAll('.icons-bar-item'));
        if (items.length < 2) return;
        const index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        const next = (index + 1) % items.length;
        track.scrollTo({left: (document.dir === 'rtl' ? -1 : 1) * next * track.clientWidth, behavior: 'smooth'});
      }, 3000);
    }
    disconnectedCallback() { clearInterval(this.rotationTimer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
